import { useState, useEffect, useContext  } from 'react';
import { AuthContext } from '../../../contexts/authContext';
import { Link, useNavigate, useLocation } from 'react-router-dom';

import { IconBuildingEstate, IconHeartFilled, IconSearch, IconChevronLeft } from '@tabler/icons-react';
import { Loader, Badge, TextInput, Select } from '@mantine/core';
import { format, parseISO } from 'date-fns';

import Box from '../../../composents/Boxes/Standard/Box';
import AppNavbarSyndic from '../../Navbar/NavbarApp';
import RessourceOptions from '../../../components/Constants/RessourcesOptions'
import AppHdWithReturnLeft from '../../../composents/Headers/AppHeaders/AppHdWithReturnLeft/AppHdWithReturnLeft';

const OffersList = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const { getToken } = useContext(AuthContext);
    const [listOffer, setlistOffer] = useState([]);
    const [soldOffers, setSoldOffers] = useState([]);
    const [search, setSearch] = useState("");
    const [contratFilter, setContratFilter] = useState("");

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const token = getToken();
        if (!token) {
            navigate("/app/login", { replace: true });
        }
          // eslint-disable-next-line react-hooks/exhaustive-deps
    },[navigate]);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = localStorage.getItem("token");

                const responseAll = await fetch(
                    "https://boldee-97d8d36af3bd.herokuapp.com/app/offers/list",
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (!responseAll.ok) return;
                const listAll = await responseAll.json();

                const filteredAll = (Array.isArray(listAll) ? listAll : []).sort((a, b) =>
                    new Date(b.createdAt) - new Date(a.createdAt)
                );

                setlistOffer(filteredAll);

                const responseSold = await fetch(
                    "https://boldee-97d8d36af3bd.herokuapp.com/app/offers/list-sold",
                    {
                        method: "GET",
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
                if (responseSold.ok) {
                    const soldData = await responseSold.json();
                    setSoldOffers(Array.isArray(soldData) ? soldData : []);
                }

            } catch (error) {
                console.error("Erreur lors du chargement des offres :", error);
            }
        };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [location.key]);


    const renderOfferCard = (offer, index, sold = false) => (
        <div key={index} style={{ margin: '5px 5px', position: 'relative', opacity: sold ? 0.5 : 1 }}>
            <Link to={`/app/offers/offer/${offer._id}`} className="aReset bT">
                <Box>
                    <div className="horizontal iCenter">
                        <div className='mrgR20 noMrgTB'>
                            {offer.pictures.length > 0
                                ?   <div>
                                        <img
                                            className="roundImg70"
                                            src={offer.pictures[0]}
                                            alt='photo_chantier'/>
                                    </div>
                                :   <>
                                        {offer.author?.company?.logo
                                            ?   <div>
                                                    <img
                                                        className="roundImg70"
                                                        src={offer.author?.company?.logo}
                                                        alt='logo'/>
                                                </div>
                                            :   <>{offer.author?.company
                                                    ? <div className="noAvatarProfileAccount">{offer.author?.company?.name.split(" ").map((word) => word.charAt(0)).join("")}</div>
                                                    : <div className="noAvatarProfileAccount"><IconBuildingEstate height={65}></IconBuildingEstate></div>
                                                }</>
                                        }
                                    </>
                            }
                        </div>
                        <div className="vertical w100">
                            <div className="horizontal iCenter" style={{ paddingRight: sold ? 56 : 0 }}>
                                <p className="txt15 mediumplus noMrgTB cap finalDots" style={{ minWidth: 0, flex: 1 }}>{offer.title}</p>
                                <span style={{ flexShrink: 0, marginLeft: 6, backgroundColor: "#2e7d32", color: "#fff", fontSize: 10, fontWeight: 700, padding: "2px 6px", borderRadius: 4 }}>
                                    {offer.contrat === "Location" ? "LOC" : offer.contrat === "Don" ? "DON" : "VTE"}
                                </span>
                            </div>
                            <div className='horizontal'>
                                <div>
                                    <p className="txt15 mediumplus noMrgTB cap mrgR3">{offer.price?.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €</p>
                                </div>
                                {offer.contrat === "Location" && (
                                    <div>
                                        <p className="txt15 mediumplus noMrgTB cap mrgL3">/ jour</p>
                                    </div>
                                )}
                                {offer.contrat === "Don" && (
                                    <div>
                                        <p className="txt15 mediumplus noMrgTB cap mrgL5">- Don</p>
                                    </div>
                                )}
                            </div>
                            <div className="horizontal iCenter noMrgTB">
                                <p className="noMrg txt13 jumpline finalDotsMed">{RessourceOptions.find(option => option.value === offer.ressource)?.group || ""}</p>
                            </div>
                            <div className="horizontal iCenter">
                                <p className="noMrg txt13 finalDotsMed">{offer.cityOfIntervention}</p>
                            </div>
                            <div className="horizontal iCenter spaceBtw">
                                <p className="txt13 noMrgTB mrgR5 txtCenter">
                                    {format(parseISO(offer.createdAt), 'dd/MM/yy')}
                                </p>
                                {offer.favCount > 0 && (
                                    <div className="horizontal iCenter" style={{ gap: 3, color: '#366641' }}>
                                        <IconHeartFilled size={13} />
                                        <span className="txt12" style={{ color: '#366641', fontWeight: 600 }}>{offer.favCount}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </Box>
            </Link>
            {sold && (
                <div style={{ position: 'absolute', top: 8, right: 14, pointerEvents: 'none' }}>
                    <Badge color="gray" variant="filled" size="sm">Vendu</Badge>
                </div>
            )}
        </div>
    );

    const mobileFilteredListOffer = contratFilter ? listOffer.filter(o => o.contrat === contratFilter) : listOffer;
    const mobileFilteredSoldOffers = contratFilter ? soldOffers.filter(o => o.contrat === contratFilter) : soldOffers;

    const offerListContent = (
        <div className='scrollableList' style={{ paddingBottom: 100 }}>
            {listOffer.length <= 0 && soldOffers.length <= 0
                ?   <div className='vertical txtCenter noMrgTB'>
                        <p className='dGreyT mrgT30 mrgB5 txt15'>Vous n'avez pas d'offre publiée</p>
                        <p className='dGreyT noMrgT txt15'>Cliquer sur + Publier</p>
                    </div>
                :   mobileFilteredListOffer.length <= 0 && mobileFilteredSoldOffers.length <= 0
                ?   <div className='vertical txtCenter noMrgTB'>
                        <p className='dGreyT mrgT30 mrgB5 txt15'>Aucun résultat trouvé</p>
                    </div>
                :   <>
                        {mobileFilteredListOffer.map((offer, index) => renderOfferCard(offer, index, false))}
                        {mobileFilteredSoldOffers.length > 0 && (
                            <>
                                {mobileFilteredSoldOffers.map((offer, index) => renderOfferCard(offer, `sold-${index}`, true))}
                            </>
                        )}
                    </>
            }
        </div>
    );

    // Même rendu "carte" que la page Recherche (AllOffersList.js) : grille de
    // 3 colonnes, photo + infos côte à côte, texte tronqué à largeur fixe.
    const renderOfferCardGrid = (offer, index, sold = false) => (
        <div key={index} style={{ position: "relative", opacity: sold ? 0.5 : 1 }}>
            <Link to={`/app/offers/offer/${offer._id}`} className="aReset bT">
                <Box>
                <div className="horizontal iCenter">

                    <div className='mrgR20 noMrgTB'>
                    {offer.pictures.length > 0
                        ? <img className="roundImg70" src={offer.pictures[0]} alt='photo_chantier' />
                        : offer.author?.company?.logo
                        ? <img className="roundImg70" src={offer.author?.company?.logo} alt='logo' />
                        : <div className="noAvatarProfileAccount">
                            {offer.author?.company
                                ? offer.author?.company?.name.split(" ").map(w => w[0]).join("")
                                : <IconBuildingEstate height={65} />}
                            </div>
                    }
                    </div>

                    <div className="vertical w100" style={{ minWidth: 0, width: 165 }}>
                        <div className="horizontal iCenter" style={{ width: 165, paddingRight: sold ? 56 : 0 }}>
                            <p className="txt15 mediumplus noMrgTB cap finalDots" style={{ minWidth: 0, flex: 1 }}>{offer.title}</p>
                            <span style={{ flexShrink: 0, marginLeft: 6, backgroundColor: "#2e7d32", color: "#fff", fontSize: 10, fontWeight: 700, padding: "2px 6px", borderRadius: 4 }}>
                                {offer.contrat === "Location" ? "LOC" : offer.contrat === "Don" ? "DON" : "VTE"}
                            </span>
                        </div>

                        <div className="horizontal">
                            <p className="txt15 mediumplus noMrgTB cap mrgR3">
                            {offer.price?.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
                            </p>

                            {offer.contrat === "Location" && <p className="txt15 mediumplus noMrgTB cap mrgL3">/ jour</p>}
                            {offer.contrat === "Don" && <p className="txt15 mediumplus noMrgTB cap mrgL3">- Don</p>}
                        </div>

                        <p className="noMrg txt13 jumpline finalDotsMed" style={{ width: 165 }}>
                            {RessourceOptions.find(option => option.value === offer.ressource)?.group || ""}
                        </p>

                        <p className="noMrg txt13 finalDotsMed" style={{ width: 165 }}>{offer.cityOfIntervention}</p>

                        <p className="txt13 noMrgTB mrgR5">
                            {format(parseISO(offer.createdAt), 'dd/MM/yy')}
                        </p>
                    </div>

                </div>
                </Box>
            </Link>
            {sold && (
                <div style={{ position: 'absolute', top: 8, right: 14, pointerEvents: 'none' }}>
                    <Badge color="gray" variant="filled" size="sm">Vendu</Badge>
                </div>
            )}
        </div>
    );

    const normalizedSearch = search.trim().toLowerCase();
    const filteredListOffer = listOffer
        .filter(o => o.title?.toLowerCase().includes(normalizedSearch))
        .filter(o => !contratFilter || o.contrat === contratFilter);
    const filteredSoldOffers = soldOffers
        .filter(o => o.title?.toLowerCase().includes(normalizedSearch))
        .filter(o => !contratFilter || o.contrat === contratFilter);

    const desktopOfferListContent = (
        <div className="mrgB100">
            {filteredListOffer.length <= 0 && filteredSoldOffers.length <= 0
                ?   <div className='vertical txtCenter noMrgTB'>
                        <p className='dGreyT mrgT30 mrgB5 txt15'>
                        {normalizedSearch === ""
                            ? "Vous n'avez pas d'offre publiée"
                            : "Aucun résultat trouvé"}
                        </p>
                    </div>
                :   <div style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(3, 320px)",
                        gap: 20,
                        justifyContent: "center"
                    }}>
                        {filteredListOffer.map((offer, index) => renderOfferCardGrid(offer, index, false))}
                        {filteredSoldOffers.map((offer, index) => renderOfferCardGrid(offer, `sold-${index}`, true))}
                    </div>
            }
        </div>
    );

    return(
        listOffer || RessourceOptions ?
            <>
                {isMobile ? (
                    <>
                        <AppNavbarSyndic />
                        <div className="stickyHeader">
                            <AppHdWithReturnLeft backTo="/app/profile/menu">Mes offres</AppHdWithReturnLeft>
                        </div>
                        {(listOffer.length > 0 || soldOffers.length > 0) && (
                            <div className="width95pCenter mrgT10">
                                <Select
                                    variant="filled"
                                    placeholder="Type d'offre"
                                    data={[
                                        { value: "Vente", label: "Vente" },
                                        { value: "Location", label: "Location" },
                                        { value: "Don", label: "Don" },
                                    ]}
                                    value={contratFilter}
                                    onChange={(v) => setContratFilter(v || "")}
                                    clearable
                                />
                            </div>
                        )}
                        <div>
                            <>
                                {offerListContent}
                            </>
                        </div>
                    </>
                ) : (
                    <>
                        <AppNavbarSyndic />
                        <div className="width90pCenter">
                        <div
                            style={{ display: "grid", gridTemplateColumns: "1fr auto 1fr", alignItems: "center", maxWidth: 1000, margin: "40px auto 0" }}
                        >
                            <button
                                type="button"
                                onClick={() => navigate(-1)}
                                style={{
                                    height: 36,
                                    width: 110,
                                    opacity: 0.9,
                                    backgroundColor: "#FFFFFF",
                                    borderRadius: 50,
                                    border: "none",
                                    padding: "0 12px",
                                    boxShadow: "0 1px 6px rgba(0,0,0,0.18)",
                                    cursor: "pointer",
                                    justifySelf: "start",
                                }}
                            >
                                <div className="horizontal iCenter">
                                    <IconChevronLeft width={20} />
                                    <p className="txt16 medium noMrgTB mrgL5">Retour</p>
                                </div>
                            </button>
                            <h2 className="noMrgTB" style={{ gridColumn: 2, justifySelf: "center" }}>Mes offres</h2>
                            <div />
                        </div>
                        </div>
                        <div className="horizontal jCenter mrgT20">
                            <TextInput
                                variant="filled"
                                size="md"
                                placeholder="🔍︎ Rechercher dans le titre"
                                leftSection={<IconSearch size={16} />}
                                value={search}
                                onChange={(e) => setSearch(e.currentTarget.value)}
                                style={{ width: 400 }}
                            />
                        </div>
                        {(listOffer.length > 0 || soldOffers.length > 0) && (
                            <div className="width90pCenter" style={{ marginTop: 16, display: "flex", justifyContent: "center" }}>
                                <div style={{ width: 960, display: "flex", justifyContent: "flex-start" }}>
                                    <Select
                                        variant="filled"
                                        placeholder="Type d'offre"
                                        data={[
                                            { value: "Vente", label: "Vente" },
                                            { value: "Location", label: "Location" },
                                            { value: "Don", label: "Don" },
                                        ]}
                                        value={contratFilter}
                                        onChange={(v) => setContratFilter(v || "")}
                                        clearable
                                        style={{ width: 160 }}
                                    />
                                </div>
                            </div>
                        )}
                        <div className="width90pCenter" style={{ marginTop: 8 }}>
                            {desktopOfferListContent}
                        </div>
                    </>
                )}
            </>
        :
         <div className="loaderWrapper vertical">
            <Loader color="green" size="sm" type="dots" />
            <div className='mrgT5'>Chargement ...</div>
        </div>
    )
}

export default OffersList;
